export default {
  left: {
    group: '我的分組',
    location: '日程地點',
    description: '日程說明',
    scoreChart: '評分表',
    scoreChartDescription: '評分表說明',
  },
  logout: '登出',
  right: {
    interviewerList: '候選人清單',
    average: '平均分',
    max: '最高分',
    min: '最低分',
    searchPlaceholder: '姓名',
    groupScore: '集體評分',
    allStart: '全部開始',
    startInterview: '開始面試',
    startVideo: '開啟視頻',
    endInterview: '结束面試',
    number: '編號',
    idCard: '身份證號',
    score: '得分',
    averageScore: '平均成績',
    class: '等級',
    checkedIn: '已簽到',
    checkIn: '簽到',
    changeScore: '修改成績',
    setScore: '評分',
  },
  noCheckedInTips: '該組有未簽到的候選人',
  noEntryTip: '當前沒有可評分的候選人',
  confirm: '確定',
  error401: '登入過期,請重新登入',
  signOutConfirm: '確定退出面試評分系統？',
  signOutCancel: '取消退出',
  status: {
    unsubmitted: '進行中',
    waiting: '未開始',
    interviewing: '進行中',
    complete: '已結束',
    processing: '已結束',
    confirmed: '已結束',
    unconfirmed: '已結束',
  },
  allStartConfirm: ['確認對該安排下所有候選人開始評分？', '確認後,您的組員可以對本安排下所有候選人進行評分'],
  startInterviewConfirm: '您即將開始面試，一旦開始操作將無法撤銷，請確認是否繼續？',
  startVideoConfirm: '您即將開啟視頻，開啟後才能開始面試，請確認是否繼續？',
  endInterviewConfirm: '結束面試後，面試無法恢復，請確認是否繼續操作？',
  unsignedInterviewersConfirm: '有評委尚未簽字，是否確定結束面試？',
  endInterviewConfirmButtonText: '確認結束',
};
